var map = {
	"./1973-1993.mdx": 68,
	"./1994-1999.mdx": 70,
	"./2006-August-22.mdx": 71,
	"./2010-2015.mdx": 73,
	"./2016-oktober-dezember.mdx": 74,
	"./2016-september-16.mdx": 76,
	"./2017-april-september.mdx": 78,
	"./2017-februar-maerz.mdx": 79,
	"./2017-september-dezember.mdx": 81,
	"./2018-april-juni.mdx": 83,
	"./2018-august-september.mdx": 84,
	"./2018-dezember.mdx": 86,
	"./2018-januar-maerz.mdx": 88,
	"./2018-juli.mdx": 90,
	"./2018-november.mdx": 91,
	"./2018-oktober-22-23.mdx": 93,
	"./2018-oktober.mdx": 95,
	"./2018-september-oktober.mdx": 96,
	"./2019-september.mdx": 98,
	"./2020-januar-2.mdx": 100,
	"./2020-januar.mdx": 20,
	"./future.mdx": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67;